<template>
  <div class="c-app" :class="rootClasses">
    <CWrapper v-if="isAuthenticated">
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <Page403Card />
          </CContainer>
        </main>
      </div>
    </CWrapper>
    <div v-else class="flex-row align-items-center">
      <CContainer>
        <Page403Card />
      </CContainer>
    </div>
  </div>
</template>

<script>
import TheHeader from '@/containers/TheHeader'

export default {
  name: 'AppPage403',
  components: {
    TheHeader,
    Page403Card: {
      template: `
        <CRow class="justify-content-center">
          <CCol md="8" lg="6">
            <CCard class="p-4">
              <CCardBody class="text-center">
                <h1 class="display-4 font-weight-bold mb-3">403</h1>
                <h2 class="h4 mb-3">Kein Zugriff</h2>
                <p class="text-muted mb-4">
                  Diese Seite ist für deinen Benutzer aktuell nicht freigeschaltet.
                </p>
                <CButton color="primary" @click="$parent.goBack()">
                  Zurück zur Übersicht
                </CButton>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      `
    }
  },
  computed: {
    darkMode () {
      return this.$store.getters['coreui/darkMode']
    },
    isAuthenticated () {
      return this.$store.getters['security/isAuthenticated']
    },
    rootClasses () {
      return {
        'c-dark-theme': this.darkMode,
        'flex-row align-items-center': !this.isAuthenticated
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/protokoll' })
    }
  }
}
</script>
